import type { IParseConfiguration } from './services/parse.service';

let configuration: IParseConfiguration | undefined;

export function configureDatamodel(value: IParseConfiguration): void {
    configuration = value;
}

export function getDatamodelConfiguration(): IParseConfiguration {
    if (!configuration) {
        throw new Error('W3Booster datamodel is not configured');
    }
    return configuration;
}
